/** Functions that can be called without authentication. All others require auth by default. */
export const PUBLIC_API_FUNCTIONS = [
  'checkUserExists',
  'getLocale',
  'signInByLink',
  'storeGetProducts_PayPro',
  'storeGetCheckout',
  'cliAuthInit',
  'cliAuthDeny',
  'cliAuthStatus',
  'coachValidateClaimToken',
  'exchangePurchaseClaimToken',
  // purchase-first Paddle buyers are logged out when they fetch their claim
  // token on Continue, so this must be callable without auth (like its sibling
  // exchangePurchaseClaimToken above). Without it the call is rejected and the
  // buyer is never signed in. See design-docs/paddle-integration.md.
  'getPaddlePurchaseClaimToken',
  // The friend who follows an invite link has no account yet, so the /invite page
  // must be able to ask who invited them without being signed in. Every failure
  // answers identically — see referralPeekInvite.ts for why that matters.
  'referralPeekInvite',
  'userSubscription',
  // the functions below are token-less Cloud Scheduler jobs: the scheduler
  // POST carries no Firebase Bearer token, so the route must be public. The
  // real auth is each handler's own scheduler-secret check on the request body.
  'tickNotifications',
  'syncMixpanelToActiveCampaign',
  'syncSubscriptionActiveToMixpanel',
  'reportDuplicateEmailAccounts',
  'reportUnmatchedStoreNotifications',
  'reportAdUploadCounts',
  'reportCoachMetrics',
  'pollAdConversionUploadStatuses',
  'syncFoodSources',
  'sweepRevsLimit',
  'sweepScanData',
  'sweepRateLimits',
  'checkBackupFreshness',
  'compactSubscriptionAuditLogs',
] as const;

export type PublicApiFunction = (typeof PUBLIC_API_FUNCTIONS)[number];

export function isPublicApiFunction(name: string): boolean {
  return (PUBLIC_API_FUNCTIONS as readonly string[]).includes(name);
}
